import getClosest from "../utilities/get-closest";

const filter = {

    elements: {},
    
    cacheDom() {
        this.elements.filters = document.querySelectorAll('.js-filter');
    },

    bind() 
    {
        const closeExpandedMenu = (event) => {
            const activeElement = document.querySelector('.filter--expanded');
            if( activeElement )
            {
                activeElement.classList.remove('filter--expanded');
            }

            if( event )
            {
                document.removeEventListener('click', closeExpandedMenu);
            }
        };

        if( this.elements.filters )
        {
            this.elements.filters.forEach( element => {
                
                element.addEventListener('click', e => {

                    if( e.target.nodeName === 'A' && ! e.target.classList.contains('js-filter-proxy')) {
                        return true;
                    }
                    
                    e.preventDefault();
                    e.stopPropagation();

                    if( element.classList.contains('js-filter-proxy') )
                    {
                        const filterContainer = getClosest(element, '.js-use-case');
                        if( filterContainer )
                        {
                            const filter = filterContainer.querySelector('div.js-filter');
                            if( filter )
                            {
                                if (filter.onclick) {
                                    filter.onclick();
                                } else if (filter.click) {
                                    filter.click();
                                }
                            }
                        }

                        return false;
                    }

                    const isActive = element.classList.contains('filter--expanded');
                    if( isActive )
                    {
                        element.classList.remove('filter--expanded');
                    }
                    else
                    {
                        closeExpandedMenu(false);
                        element.classList.add('filter--expanded');
                        document.addEventListener('click', closeExpandedMenu)
                    }
                });
            });
        }
    },

    init() {
        this.cacheDom();
        this.bind();
    }
}

export default filter;